import {
  Table2, Users2, FileText, FolderOpen, MessagesSquare, ListChecks, Wallet, UserCog, Sparkles,
} from "lucide-react";

export const NAV_ITEMS = [
  { key: "tabella", label: "Tabella operativa", path: "/", icon: Table2 },
  { key: "clienti", label: "Clienti", path: "/clienti", icon: Users2 },
  { key: "piano", label: "Piano editoriale", path: "/piano-editoriale", icon: FileText },
  { key: "calendario", label: "Tasks", path: "/calendario", icon: ListChecks },
  { key: "drive", label: "Drive", path: "/drive", icon: FolderOpen },
  { key: "chat", label: "Chat", path: "/chat", icon: MessagesSquare },
  { key: "pagamenti", label: "Pagamenti", path: "/pagamenti", icon: Wallet, adminOnly: true },
  { key: "utenti", label: "Utenti e ruoli", path: "/utenti", icon: UserCog, adminOnly: true },
  { key: "agenti", label: "Agenti AI", path: "/agenti", icon: Sparkles, adminOnly: true },
];

export const visibleNav = (user) => NAV_ITEMS.filter((i) => !i.adminOnly || user?.role === "admin");
